<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="100px"
          :model="queryForm"
          @submit.native.prevent
        >
          <el-form-item label="banner名称">
            <el-input
              v-model="dialogForm.name"
              placeholder="请输入banner名称"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
              v-model="queryForm.dateRange"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态" prop="state">
            <el-select v-model="dialogForm.state"  clearable placeholder="请选择banner状态">
              <el-option
                v-for="item in businessList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
            <el-button @click="handleAdd" icon="el-icon-plus" v-hasPermi="['Island:banner:add']" type="primary">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="banner编号"
          prop="id"
          height="500"
        />
        <el-table-column
          align="center"
          label="名称"
          prop="title"
          width="180"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="跳转方式"
          prop="psp_order_id"
          height="500"
        >
          <template slot-scope="scope">
            <span >{{ jumpType[scope.row.jump_type] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="开始日期"
          prop="psp_order_id"
          height="500"
        >
          <template slot-scope="scope">
            <span >{{ transTime(scope.row.start_time) }}</span>
          </template>  
        </el-table-column>
        <el-table-column
          align="center"
          label="结束日期"
          prop="psp_order_id"
          height="500"
        >
          <template slot-scope="scope">
            <span >{{ transTime(scope.row.end_time) }}</span>
          </template>  
        </el-table-column>
        <el-table-column
          align="center"
          label="创建日期"
          prop="psp_order_id"
          height="500"
        >
          <template slot-scope="scope">
            <span >{{ transTime(scope.row.insert_time) }}</span>
          </template>  
        </el-table-column>
        <el-table-column
          align="center"
          label="排序"
          prop="order_by"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="状态"
          prop="psp_order_id"
          height="500"
        >
          <template slot-scope="scope">
            <span >{{ statusType[scope.row.status] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="280">
          <template #default="{ row }">
            <el-button
              size="small"
              type="primary"
              v-hasPermi="['Island:banner:edit']"
              @click="handEdit(row)"
            >
              编辑
            </el-button>
            <el-button
              size="small"
              type="danger"
              v-hasPermi="['Island:banner:delete']"
              @click="handleDelete(row)"
              >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
    <el-dialog
      title="是否确认退款？"
      :visible.sync="dialogVisible"
      width="20%"
      center
    >
    </el-dialog>
  </div>
</template>

<script>
import { transTime } from '@/utils/transTime'
import { getBannerApi, delBannerApi } from '@/api/radio'
import { Message } from "element-ui";

export default {
  data() {
    return {
      transTime,
      jumpType: {
        '0': '不跳转',
        '1': '详情图文页',
        '2': '指定页面'
      },
      statusType: {
        '1': '生效中',
        '2': '待生效',
        '3': '已结束'
      },
      businessList: [
        {
          label: '生效中',
          id: 1
        }, 
        {
          label: '待生效',
          id: 2
        },
        {
          label: '已结束',
          id: 3
        }
      ],
      queryForm: {
        page: 1,
        pageSize: 10,

        timeRange: "0", // 时间范围(默认是查询2小时内的数据)
        dateRange: [], // 时间段
      }, // 搜索条件表单
      dialogVisible: false, // 模态框是否展示
      dialogForm: {
        name: '',
        state: null,
      }, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数
      start: '',
      end: '',
      tableData: [],
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {},

  methods: {
    dateChange(val) {
      if(val){
        const [start, end] = val
        this.start = start + ' 00:00:00'
        this.end = end + ' 23:59:59'
      } else {
        this.start = ''
        this.end = ''
      }
    },
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    handleQuery() {
      this.queryForm.page = 1;
      this.fetchData();
    },
    handleAdd(){
      this.$router.push({
        path: '/bannerAdd',
        query: { 
          type: 'add',
          length: this.tableData.length ? this.tableData[0].order_by : 0
        }
      })
    },
    handEdit(row){
      sessionStorage.setItem('banner', JSON.stringify(row))
      this.$router.push({
        path: '/bannerAdd',
        query: { 
          type: 'edit',
          length: this.tableData.length ? this.tableData[0].order_by : 0
          // row: JSON.stringify(row)
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delBannerApi({id: row.id}).then(res => {
          if(res && res.code){
            this.fetchData()
          }
        })
      }).catch(() => {
      })
    },
    async fetchData() {
      // 这里发请求
      let params = {
        name: this.dialogForm.name,
        status: this.dialogForm.state,
        start: this.start,
        end: this.end,
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
      };
      await getBannerApi(params)
        .then((res) => {
          if (res && res.code) {
            this.tableData = res.data.data_list
            this.total = res.data.total_record // 总共数量
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.tableCard {
  margin-top: 20px;
}
.el-pagination {
  text-align: center;
  margin-top: 10px;
}

</style>